// Module
var code = " <el-button class=\"task-status-badge\" v-bind:style=\"styleObject\"> <div> {{ statusName }} <span v-if=\"isArrowIcon\"> <i class=\"el-icon-arrow-down dropdown-btn__arrow\" v-bind:class=\"{'icon--rigth': isArrowIcon}\"> </i> </span> </div> </el-button> ";
// Exports
module.exports = code;